import { Shopify } from "@models/shopify.model";
/**
 *
 * @desc Surfaces content from a shopify connection.
 * @param {Shopify.Connection<T>} contentEdges - A connection fetched from the Storefront API.
 * @returns {Array<T>} Array of content
 *     Returns an empty array if no orders exist.
 */
export const getNodes = <T>(contentEdges: Shopify.Connection<T>): T[] => {
  return (contentEdges.edges?.map((edge) => edge.node).flat() || []) as T[];
};
